import { useAppStore } from '@/store/useAppStore';
import { useOrganizationOnboardingStore } from '@/store/useOrganizationOnboardingStore';
import { useScreenerStore } from '@/store/useScreenerStore';
import { useUserOnboardingStore } from '@/store/useUserOnboardingStore';
import { queryClient } from '@/services/queryClient';

/**
 * Remove all client-side state that may belong to the authenticated user.
 *
 * Query keys are intentionally shared between users, so invalidating them is not
 * sufficient: inactive queries could still expose the previous user's data until
 * their next refetch. Clearing the client also cancels/destroys in-flight queries
 * so they cannot repopulate the cache after logout.
 */
export const resetUserSession = (): void => {
  queryClient.clear();

  useUserOnboardingStore.getState().reset();
  useOrganizationOnboardingStore.getState().reset();
  useAppStore.getState().reset();
  useScreenerStore.getState().reset();
};
